module.exports = require('./AssigneeCell');
